module.exports = require('./AssigneeCell');
